import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";

const appearance = {
  theme: dark,
  variables: {
    colorPrimary: "#00F0FF",
    colorPrimaryForeground: "#090E17",
    colorBackground: "#131B26",
    fontFamily: "Plus Jakarta Sans, sans-serif",
    borderRadius: "0.8rem",
  },
  captcha: { theme: "dark" },
};

const localization = {
  locale: "ro-RO",
  socialButtonsBlockButton: "Continuă cu {{provider|titleize}}",
  dividerText: "sau",
  formFieldLabel__emailAddress: "Adresă de email",
  formFieldLabel__password: "Parolă",
  formFieldLabel__firstName: "Prenume",
  formFieldLabel__lastName: "Nume",
  formButtonPrimary: "Continuă",
  formFieldInputPlaceholder__emailAddress: "Introdu adresa de email",
  formFieldInputPlaceholder__password: "Introdu parola",
  formFieldAction__forgotPassword: "Ai uitat parola?",
  signInOrUp: { title: "Autentificare manager", subtitle: "Intră în panoul spălătoriei" },
  signIn: {
    start: {
      title: "Autentificare manager",
      titleCombined: "Autentificare manager",
      subtitle: "Intră în panoul spălătoriei",
      subtitleCombined: "Intră în panoul spălătoriei",
      actionText: "Nu ai cont?",
      actionLink: "Creează cont",
    },
    password: { title: "Introdu parola", actionLink: "Folosește altă metodă" },
  },
  signUp: {
    start: {
      title: "Creează cont",
      subtitle: "Pentru echipa spălătoriei",
      actionText: "Ai deja cont?",
      actionLink: "Autentifică-te",
    },
  },
  userButton: { action__signOut: "Deconectare", action__manageAccount: "Gestionează contul" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Autentificarea nu este disponibilă acum. Reîncarcă pagina.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={localization}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/admin"
      signUpFallbackRedirectUrl="/admin"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
